module.exports = __webpack_public_path__ + "img/yzb@3x.1bb8de87.png";